<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCloseModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="modal-title">
        {{ "delete_page" | translate }}
    </h3>
</div>
<div class="modal-body">
    {{ "confirm_delete_page" | translate }}: <b>{{ page.name }}</b
    >?
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="onCancel()">
        {{ "cancel" | translate }}
    </button>
    <button class="btn btn-danger" type="button" (click)="onConfirm()">
        {{ "delete" | translate }}
    </button>
</div>
